import { useEffect, useState } from "react";
import {
  Badge,
  Flex,
  Progress,
  Table,
  Card,
  Collapse,
  Tooltip,
  Drawer,
  Typography,
  Avatar,
  Descriptions,
  Button,
} from "antd";
import {
  ClockCircleOutlined,
  ToolOutlined,
  CheckCircleOutlined,
  ApartmentOutlined,
  PieChartOutlined,
} from "@ant-design/icons";

import { show_bach_progress_flow } from "../../utils/api";
// ==============================|| MONTHLY BAR CHART ||============================== //

const BatchProgressView = ({ progressView, setProgressView, batch_number }) => {
  const [progressData, setProgressData] = useState([]);
  const get_progress_view = async () => {
    try {
      if (batch_number) {
        await show_bach_progress_flow(
          { batch_number: batch_number },
          success_get_progress_view
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_get_progress_view = (res) => {
    console.log(res);
    if (res?.data?.status === "success" && res?.data?.data) {
      setProgressData(res?.data?.data[0]);
    } else {
    }
  };

  useEffect(() => {
    get_progress_view();
  }, []);

  return (
    <div className="flex gap-2">
      <Tooltip title={progressView ? "View Dag Flow" : "View Progress"}>
        <Button
          type="text"
          shape="circle"
          icon={
            progressView ? (
              <ApartmentOutlined style={{ color: "orange" }} />
            ) : (
              <PieChartOutlined style={{ color: "#52c41a" }} />
            )
          }
          onClick={() => {
            setProgressView(!progressView);
          }}
        />
      </Tooltip>

      <div className="grid grid-cols-12 gap-4 mt-4 w-full">
        <div className="col-span-12 md:col-span-4">
          <Card>
            <Typography.Title
              level={5}
              style={{ fontWeight: "bold", marginBottom: 16 }}
            >
              Batch Completion Progress
            </Typography.Title>
            <div className="flex justify-center gap-10">
              <Tooltip
                title={`Progress:${progressData?.batch_progress_percentage}`}
              >
                <div className="flex flex-col items-center">
                  <Progress
                    type="dashboard"
                    steps={6}
                    percent={progressData?.batch_progress_percentage || 0}
                    strokeWidth={20}
                  />
                  <Typography.Text strong>
                    Completed Operations
                  </Typography.Text>
                </div>
              </Tooltip>

              <Tooltip
                title={`Progress:${progressData?.batch_progress_percentage}`}
              >
                <div className="flex flex-col items-center">
                  <Progress
                    type="dashboard"
                    percent={progressData?.process_progress_percentage || 0}
                    strokeWidth={20}
                  />
                  <Typography.Text strong>Completed Process</Typography.Text>
                </div>
              </Tooltip>
            </div>
          </Card>
        </div>

        <div className="col-span-12 md:col-span-8">
          <Card>
            <Typography.Title
              level={5}
              style={{ fontWeight: "bold", marginBottom: 16 }}
            >
              Execution Progress
            </Typography.Title>
            <div className="flex flex-col gap-6">
              <Flex align="center" gap={8}>
                <Avatar icon={<ToolOutlined />} size={24} />
                <Typography.Text strong>
                  Cumulative Time Completed
                </Typography.Text>
                <Progress
                  percent={progressData?.cumulative_time_completed || 0}
                  style={{ flex: 1 }}
                />
              </Flex>
              <Flex align="center" gap={8}>
                <Avatar icon={<ClockCircleOutlined />} size={24} />
                <Typography.Text strong>
                  Additional Time Utilization
                </Typography.Text>
                <Progress
                  percent={
                    progressData?.additional_time_utilization_percent || 0
                  }
                  style={{ flex: 1 }}
                />
              </Flex>
              <Flex align="center" gap={8}>
                <Avatar icon={<CheckCircleOutlined />} size={24} />
                <Typography.Text strong>
                  Total Skip Operations
                </Typography.Text>
                <Progress
                  percent={progressData?.total_skip_operations || 0}
                  style={{ flex: 1 }}
                />
              </Flex>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default BatchProgressView;
